import { openModal } from '@core/components/ModalStack';
import { AddEditChecklistTemplateModalProps } from './AddEditChecklistTemplateModal';

export async function openAddEditChecklistTemplateModal(props: AddEditChecklistTemplateModalProps) {
  const { AddEditChecklistTemplateModal } = await import('./AddEditChecklistTemplateModal');

  openModal(AddEditChecklistTemplateModal, props);
}
